import { x, styled } from '@xstyled/styled-components';
import React from 'react';
import { Flex } from '~/ui/flex/Flex';
import { Logo } from '~/ui/logo/Logo';
import { TrainingState, useTrainingStore } from '../state';
import HomeIcon from '~/assets/icons/home.svg';
import { t } from 'ttag';
import { Documents } from '../documents/Documents';
import { select } from '~/lib/select';

const selector = (s: TrainingState) =>
  select(s, 'logoUrl', 'learnerPortalUrl', 'featureShowHomeButton');

export const HomeButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 10px;
  border: 1px solid ${p => p.theme.colors.greyMed};
  border-radius: 10px;
`;

export const Header = () => {
  const { learnerPortalUrl, logoUrl, featureShowHomeButton } =
    useTrainingStore(selector);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let RXD: any;

  try {
    if (window.document.referrer) {
      const preUrl = window?.document?.referrer;
      const domain = preUrl?.split('/')[2];

      if (domain !== 'localhost:8000' && domain !== 'www.easyllama.com') {
        RXD = (window.parent as any)?.RXD;
      }
    } else {
      RXD = (window.parent as any)?.RXD;
    }
  } catch (error) {
    // console.error('RXD:', error);
  }

  const concedeControl = () => {
    if (typeof RXD !== 'undefined') {
      setTimeout(() => {
        // putting this in the timeout to give chance for the previous RXD calls to fully complete...
        RXD?.ConcedeControl();
      });
    }
  };

  return (
    <Flex alignItems="center" justifyContent="space-between" p="md">
      <x.div w="20" tabIndex={-1} />
      <x.div className="logoStyleForDarkTheme" tabIndex={-1}>
        <Logo src={logoUrl} height={36} />
      </x.div>
      <x.div display="flex" alignItems="center" gap="sm">
        <Documents />
        {!RXD && featureShowHomeButton && (
          <HomeButton
            target="_blank"
            href={learnerPortalUrl}
            aria-label={t`Home`}
            tabIndex={2}
          >
            <HomeIcon
              aria-hidden="true"
              className="icon"
              onClick={concedeControl}
            />
          </HomeButton>
        )}
      </x.div>
    </Flex>
  );
};
